
let auteurapi = {

    getAuteur : function(id){

        // this returns a jquery deferred object, which is more or less like a Promise
        var dfd = $.Deferred();
        $.get('/api/auteur/' + id)
                .then((res)=>{
                    // res : {total, data}
                    dfd.resolve(res);
                })
                .fail((jqXHR, status,error)=>{
                    dfd.reject(error);
                });
        return dfd.promise();
    },

    getAuteurLivres : function(id){

        // this returns a jquery deferred object, which is more or less like a Promise
        var dfd = $.Deferred();
        $.get('/api/auteur/' + id + '/crit')
                .then((res)=>{
                    if (res.result == 0){
                        dfd.resolve(res);
                    } else {
                        dfd.reject(res.message);
                    }
                })
                .fail((jqXHR, status,error)=>{
                    dfd.reject(error);
                });
        return dfd.promise();
    },


    getBioBiblio : function(aid){

        // this returns a jquery deferred object, which is more or less like a Promise
        var dfd = $.Deferred();
        $.get('/api/auteur/' + aid + '/biobiblio')
                .then((res)=>{
                    if (res.result == -1){
                        return dfd.reject(res.message);
                    }
                    // res : {total, data}
                    dfd.resolve(res);
                })
                .fail((jqXHR, status,error)=>{
                    dfd.reject(error);
                });
        return dfd.promise();
    },

    getAuteurLiens : function(id){
        var dfd = $.Deferred();
        $.get('/api/auteur/' + id + '/liens')
                .then((res)=>{
                    // res : {total, data}
                    dfd.resolve(res);
                })
                .fail((jqXHR, status,error)=>{
                    dfd.reject(error);
                });
        return dfd.promise();        
    },

    saveBioBiblio : function(is_bio,aid,html){
        var dfd = $.Deferred();
        $.ajax({
            'method' : 'POST',
            'url' : '/api/auteur/' + aid + '/biobiblio',
            'data' : {'bio' : is_bio, 'texte' : html},
            'success' : function(data){
                if (data.result == 0){
                    dfd.resolve(data);
                } else {
                    dfd.reject(data.message || 'une erreur imprévue a eu lieue');
                }
            },
            'error' : function(jqXHR,textStatus,error){
                dfd.reject(error);
            }
        });
        return dfd.promise();
    },

    saveAuteurLien : function(aid,lien){
        var dfd = $.Deferred();
        $.ajax({
            'method' : 'POST',
            'url' : '/api/auteur/' + aid + '/lien',
            'data' : lien,
            'success' : function(res){
                if (res.result == 0){
                    dfd.resolve(res.lien);
                } else {
                    dfd.reject(res.message || 'une erreur imprévue a eu lieu');
                }
            },
            'error' : function(jqXHR,textStatus,error){
                dfd.reject(error);
            }
        });
        return dfd.promise();
    },

    hideAuteurLien : function(aid,id){
        var dfd = $.Deferred();
        $.ajax({
            'method' : 'POST',
            'url' : '/api/auteur/' + aid + '/lien',
            'data' : {'action': 'hide', 'id': id},
            'success' : function(res){
                if (res.result == 0){
                    dfd.resolve(res);
                } else {
                    dfd.reject(res.message || 'une erreur imprévue a eu lieu');
                }
            },
            'error' : function(jqXHR,textStatus,error){
                dfd.reject(error);
            }
        });
        return dfd.promise();
    },

    saveDates : function(aid,d1,d2){
        var dfd = $.Deferred();
        $.ajax({
            'method' : 'POST',
            'url' : '/api/auteur/' + aid + '/dates',
            'data' : {'date1': d1, 'date2': d2},
            'success' : function(res){
                if (res.result == 0){
                    dfd.resolve(res);
                } else {
                    dfd.reject(res.message || 'une erreur imprévue a eu lieu');
                }
            },
            'error' : function(jqXHR,textStatus,error){
                dfd.reject(error);
            }
        });
        return dfd.promise();        
    }

}

export default auteurapi


// WEBPACK FOOTER //
// ./shared/webapi/auteurapi.js